module.exports = __webpack_public_path__ + "img/tusmileonly.182f5a03.png";